import smoothscroll from 'smoothscroll-polyfill'
import scroller from './src/utils/scroller'

smoothscroll.polyfill()

export const shouldUpdateScroll = ({ routerProps }) => {
	const { disableScrollUpdate } = routerProps.location.state ?? {}

	if (disableScrollUpdate) return false

	if (typeof window !== 'undefined') return window.scrollTo({ left: 0, top: 0, behavior: 'auto' })

	return [0, 0]
}

export const onInitialClientRender = () => {
	setTimeout(() => {
		const anchor = window.location.hash.slice(1)
		if (anchor) scroller(anchor, -140)
	})
}

export { default as wrapPageElement } from 'components/GatsbyLayout'
